// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-toolbar[data-v-7280e13c]{background-color:#fff!important;background-color:var(--ui-bg-surface,#fff)!important;border-bottom:1px solid #eef0f3!important;border-bottom:1px solid var(--ui-border,#eef0f3)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
